import { render, staticRenderFns } from "./kitchen.vue?vue&type=template&id=8610cbe0&scoped=true&"
import script from "./kitchen.vue?vue&type=script&lang=js&"
export * from "./kitchen.vue?vue&type=script&lang=js&"
import style0 from "./kitchen.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./kitchen.vue?vue&type=style&index=1&id=8610cbe0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8610cbe0",
  null
  
)

export default component.exports